import React from 'react'
import { Link } from 'react-router-dom'

const InvoiceTypeSubmenu = ({ utility_invoice_link,
    proforma_invoice_link, setShowInvoice }: {
        utility_invoice_link: string,
        proforma_invoice_link: string,
        setShowInvoice: (showInvoice: string | null)=>void
    }) => {
    return (
        <div
            className='position-absolute show menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-2 fs-6 w-200px'
            style={{ zIndex: 105, marginTop: 3 }}
            data-kt-menu='true'
        >
            {
                proforma_invoice_link &&
                <div className='menu-item px-5' onClick={()=>setShowInvoice(null)}>
                    <Link to={proforma_invoice_link} target="_blank" className='menu-link px-5'>
                        Rent Invoice
                    </Link>
                </div>
            }
            {
                utility_invoice_link &&
                <div className='menu-item px-5' onClick={()=>setShowInvoice(null)}>
                    <Link to={utility_invoice_link} target="_blank" className='menu-link px-5'>
                        Utility Invoice
                    </Link>
                </div>
            }

        </div>
    )
}

export default InvoiceTypeSubmenu